import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { GestionTvaComponent } from './../../../../core/gestion-referentiel/gestion-tva/gestion-tva.component';
import { TvaModel } from './../../../models/simple-types/tva.model';
import { TvaService } from './../../../services/simple/tva.service';
import { Form, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, OnChanges } from '@angular/core';

export interface DialogData {
      form: UntypedFormGroup;
      tvas: TvaModel[];
      result: boolean;
    }
@Component({
      selector: 'app-modal-add-tva',
      templateUrl: './modal-add-tva.component.html',
      styleUrls: ['./modal-add-tva.component.scss']
    })

export class ModalAddTvaComponent implements OnInit {
  tvas: TvaModel[];
  form: UntypedFormGroup;
    constructor(public dialog: MatDialog
      , public dialogRef: MatDialogRef<GestionTvaComponent>
      , @Inject(MAT_DIALOG_DATA) public data: DialogData
      , private toastr: ToastrService
      , private router: Router
      , private tvaService: TvaService) {
    }

  ngOnInit(): void {
    this.tvas = this.data.tvas;
    this.form = this.data.form;
  }

  onModalCancel(): void {
    this.data.result = false;
    this.dialogRef.close(false);
  }

  onModalConfirm(): void {
    if (this.form.valid) {
      const tva = this.form.getRawValue();
      // Création
      if (!this.form.get('id').value){
        const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.tvaService.save(tva).subscribe((a: TvaModel) => {
            this.toastr.success('', 'Création de la tva ' + a.code + ' réussie');
            this.dialogRef.close(true);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(true);
            dialogRef.close();
          });
      }else { // Modification
        const dialogRef = this.dialog.open(SpinnerModalComponent);
        this.tvaService.update(tva.id, tva).subscribe((a: TvaModel) => {
          this.toastr.success('', 'Modification de la tva ' + a.code + ' réussie');
          this.dialogRef.close(true);
          dialogRef.close();
        }, (error) => {
          this.dialogRef.close(true);
          dialogRef.close();
        });
      }
    } else {
      this.displayErrors();
      this.toastr.warning('', 'Veuillez remplir les champs obligatoire');
    }
  }

  displayErrors(): void {
    for (const index in this.form.controls) {
      if (index) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}

